import React, {useEffect} from 'react';
import './accountFinance.scss';

import {Footer, Navigation} from "../../components";
import AccountFinanceHero from "./sections/hero/AccountFinanceHero";
import BusinessLoans from "./sections/business-loans/BusinessLoans";
import GetStartedGlobal from "../../components/get-started-global/GetStartedGlobal";
import Banks from "./sections/banks/Banks";
import OtherHelp from "./sections/other-help/OtherHelp";
import FinanceEvents from "./sections/events/FinanceEvents";
import HeroInfo from "./sections/hero-info/HeroInfo";

const AccountFinance = () => {
    useEffect(() => {
        window.scrollTo(0, 0);

    }, []);
    return (
        <div className={'account-finance'}>
            <div className="account-finance_nav">
                <Navigation/>
            </div>
            <AccountFinanceHero/>
            <HeroInfo/>
            <OtherHelp/>
            <BusinessLoans/>
            <Banks/>
            <FinanceEvents/>
            <GetStartedGlobal/>
            <Footer/>
        </div>
    );
};

export default AccountFinance;
